import React, { Fragment } from 'react'
import style from './button.mod.scss'
import { useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { TransitionLink } from '../../helpers/pageTransitions'
import Scroll from '@helpers/scroll'

const Button = ({
  to = '/',
  children,
  type = null,
  url = false,
  title,
  onClick,
  noTarget = false,
  modifiers = [],
  disabled,
  isExternal = false,
  isMenuItem = false,
  unstyled = false,
  activeClass = '',
  gaTarget,
  ...props
}) => {
  const data = useStaticQuery(graphql`
    query SiteUrlQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  if (url) {
    to = url
    console.info(`url on button is deprecated. Update`)
  }

  if (!url && !to) {
    to = '/'
  }

  props.secondary && modifiers.push(`${style.button}--secondary`)
  props.white && modifiers.push(`${style.button}--white`)
  props.secondary &&
    props.white &&
    modifiers.push(`${style.button}--secondary--white`)
  props.fullWidthMobile && modifiers.push(`${style.button}--full-width-mobile`)
  props.fullWidth && modifiers.push(`${style.button}--full-width`)
  isMenuItem && modifiers.push(`${style.button}--menu-item`)
  props.short && modifiers.push(`${style.button}--short`)
  props.wide && modifiers.push(`${style.button}--wide`)
  props.circular && modifiers.push(`${style.button}--circular`)
  props.block && modifiers.push(`${style.button}--block`)
  props.tertiary && modifiers.push(`${style.button}--tertiary`)
  props.centered && modifiers.push(`${style.button}--centered`)

  const ButtonContent = () => (
    <Fragment>
      <span className={style.button__text}>{children}</span>
    </Fragment>
  )

  const { siteUrl } = data.site.siteMetadata

  const externalLink =
    isExternal ||
    (to.search(/http/g) > -1 && to.search(siteUrl) === -1) ||
    to.search(/^tel:/g) > -1 ||
    to.search(/^mailto:/g) > -1 ||
    (isExternal && modifiers.push(`${style.button}--external`))

  const scrollLink = to.search(/^#/g) > -1

  const activeClassConfig = {
    activeClassName:
      !scrollLink &&
      !externalLink &&
      !type &&
      activeClass &&
      style[`button--${activeClass}`]
  }

  const config = {
    className: unstyled
      ? [style['button--unstyled'], ...modifiers].join(' ')
      : [style.button, ...modifiers].join(' '),
    onClick
  }

  if (gaTarget) config['data-ga-target'] = gaTarget

  if (!noTarget && externalLink) {
    config.target = '_blank'
    config.rel = 'noopener noreferrer'
  }

  if (title && type) {
    config.ariaLabel = title
  }

  if (title && !type) {
    config.title = title
  }

  if (disabled) config.disabled = 'disabled'

  if (externalLink) {
    return (
      <a href={to} {...config}>
        <ButtonContent />
      </a>
    )
  } else if (scrollLink) {
    return (
      <Scroll type="id" element={to.replace('#', '')}>
        <a href={to} {...config}>
          <ButtonContent children={children} />
        </a>
      </Scroll>
    )
  } else if (type) {
    return (
      <button type={type} {...config}>
        <ButtonContent />
      </button>
    )
  } else {
    return (
      <TransitionLink
        to={to.replace(siteUrl, '')}
        {...config}
        {...activeClassConfig}
      >
        <ButtonContent />
      </TransitionLink>
    )
  }
}

export default Button

Button.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  url: PropTypes.string,
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  size: PropTypes.string,
  modifiers: PropTypes.array
}
